import {TradingAccountDetailRecord} from "../../../../types/TradingAccountDetailRecord";

export function formatAddress(tradingAccountDetail: TradingAccountDetailRecord): string | null {
    let address = "";

    if (tradingAccountDetail.addressLine1 != null) {
        address += tradingAccountDetail.addressLine1;
    }

    if (tradingAccountDetail.addressLine2 != null) {
        address += " ";
        address += tradingAccountDetail.addressLine2;
    }

    if (tradingAccountDetail.addressLine3 != null) {
        address += " ";
        address += tradingAccountDetail.addressLine3;
    }

    if (tradingAccountDetail.addressLine4 != null) {
        address += " ";
        address += tradingAccountDetail.addressLine4;
    }

    if (address === "") {
        return null;
    } else {
        return address;
    }
}
